"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
var Video = (0, createSvgIcon_1.default)(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M1.46387 14.5H15.4639C16.0639 14.5 16.4639 14.1 16.4639 13.5V1.5C16.4639 0.9 16.0639 0.5 15.4639 0.5H1.46387C0.863867 0.5 0.463867 0.9 0.463867 1.5V13.5C0.463867 14.1 0.863867 14.5 1.46387 14.5ZM14.4639 12.5H2.46387V2.5H14.4639V12.5Z" }),
    React.createElement("path", { d: "M11.2808 7.16565L7.02116 4.55373C6.77438 4.40241 6.46387 4.5887 6.46387 4.88808V10.1119C6.46387 10.4113 6.77438 10.5976 7.02116 10.4463L11.2808 7.83435C11.5249 7.68467 11.5249 7.31533 11.2808 7.16565Z" })), 'Video');
exports.default = Video;
//# sourceMappingURL=index.js.map